import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';

export const GET_PHONEPE_BALANCE_REQUEST = 'GET_PHONEPE_BALANCE_REQUEST';
export const GET_PHONEPE_BALANCE_ERROR = 'GET_PHONEPE_BALANCE_ERROR';
export const GET_PHONEPE_BALANCE_SUCCESS = 'GET_PHONEPE_BALANCE_SUCCESS';

export const CLEAR_GET_PHONEPE_BALANCE = 'CLEAR_GET_PHONEPE_BALANCE';

export const DRAW_PHONEPE_BALANCE_REQUEST = 'DRAW_PHONEPE_BALANCE_REQUEST';
export const DRAW_PHONEPE_BALANCE_ERROR = 'DRAW_PHONEPE_BALANCE_ERROR';
export const DRAW_PHONEPE_BALANCE_SUCCESS = 'DRAW_PHONEPE_BALANCE_SUCCESS';

export const ACTIVATE_PHONEPE_REQUEST = 'ACTIVATE_PHONEPE_REQUEST';
export const ACTIVATE_PHONEPE_ERROR = 'ACTIVATE_PHONEPE_ERROR';
export const ACTIVATE_PHONEPE_SUCCESS = 'ACTIVATE_PHONEPE_SUCCESS';

export function getBalanceRequestAction() {
	return { type: GET_PHONEPE_BALANCE_REQUEST };
}

export function getBalanceErrorAction(error) {
	return { type: GET_PHONEPE_BALANCE_ERROR, error };
}

export function getBalanceSuccessAction(data) {
	return { type: GET_PHONEPE_BALANCE_SUCCESS, data };
}

export function drawBalanceRequestAction() {
	return { type: DRAW_PHONEPE_BALANCE_REQUEST };
}

export function drawBalanceErrorAction(error) {
	return { type: DRAW_PHONEPE_BALANCE_ERROR, error };
}

export function drawBalanceSuccessAction(data) {
	return { type: DRAW_PHONEPE_BALANCE_SUCCESS, data };
}

export function clearPhonePeBalanceAction() {
	return { type: CLEAR_GET_PHONEPE_BALANCE };
}

export function activePhonePeRequestAction() {
	return { type: ACTIVATE_PHONEPE_REQUEST };
}

export function activePhonePeErrorAction(error) {
	return { type: ACTIVATE_PHONEPE_ERROR, error };
}

export function activePhonePeSuccessAction(data) {
	return { type: ACTIVATE_PHONEPE_SUCCESS, data };
}

export function getWalletBalance() {
	return (dispatch, getState) => {
		dispatch(getBalanceRequestAction());
		ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/wallet/balance',
				headers: Object.assign({}, headers)
			})
		)
			.then(data => {
				return dispatch(getBalanceSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				dispatch(getBalanceErrorAction(err));
				return Promise.reject(err);
			});
	};
}

export function drawPhonePeBalance(callBackURL) {
	return (dispatch, getState) => {
		dispatch(drawBalanceRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/wallet/moveout',
				headers: Object.assign({}, headers)
			}),
			{ callbackURL: callBackURL }
		)
			.then(data => {
				return dispatch(drawBalanceSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				dispatch(drawBalanceErrorAction(err));
				return Promise.reject(err);
			});
	};
}

export function activePhonePeAction(callBackURL) {
	return (dispatch, getState) => {
		dispatch(activePhonePeRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/wallet/activation-link',
				headers: Object.assign({}, headers)
			}),
			{ callbackURL: callBackURL }
		)
			.then(data => {
				return dispatch(activePhonePeSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				dispatch(activePhonePeErrorAction(err));
				return Promise.reject(err);
			});
	};
}
